<div class="format-view_header">
  <span class="format-view_title">{{ data.title | translate }}</span>
  @if (showAutoImportExcludedToggle) {
    <div class="format-view_header-control">
      <celum-icon [clickable]="false" [configuration]="icons.autoImportExcluded"></celum-icon>
      <span>{{ 'BASE_FORMAT_VIEW_DIALOG.AUTO_IMPORT_EXCLUDED_TOGGLE_LABEL' | translate }}</span>
      <mat-slide-toggle data-test-auto-import-excluded-toggle [formControl]="formatFormService.formatForm.controls.autoImportExcluded"></mat-slide-toggle>
    </div>
  }
  @if (isAdmin()) {
    <div class="format-view_header-control" [matTooltip]="'FORMAT_VIEW_DIALOG.PROTECTED_ICON_TOOLTIP' | translate">
      <celum-icon [clickable]="false" [configuration]="icons.protected"></celum-icon>
      <span>{{ 'FORMAT_VIEW_DIALOG.PROTECTED_TOGGLE_LABEL' | translate }}</span>
      <mat-slide-toggle [formControl]="formatFormService.formatForm.controls.isProtected"></mat-slide-toggle>
    </div>
  }
  <button
    celum-button
    data-test-create-or-save-format-button
    mat-flat-button
    class="format-view_action"
    color="primary"
    size="small"
    [disabled]="formatFormService.saveDisabled()"
    (click)="onSubmit()">
    <celum-icon [configuration]="icons.create"></celum-icon>
    {{ data.action | translate }}
  </button>
  <mat-divider class="format-view_divider" [vertical]="true"></mat-divider>
  <button
    celum-square-button
    data-test-close-format-dialog
    mat-button
    class="format-view_close"
    [matTooltip]="'COMMON.CLOSE' | translate"
    (click)="closeDialog()">
    <celum-icon [configuration]="icons.close"></celum-icon>
  </button>
</div>
<div class="format-view_content">
  <div class="format-view_section">
    <div class="format-view-shared_section-header">
      <span class="format-view-shared_section-title">{{ 'FORMAT_VIEW_DIALOG.DETAILS_SECTION' | translate }}</span>
    </div>
    <form [formGroup]="formatFormService.formatForm">
      <div class="format-view-shared_field">
        <span class="format-view-shared_field-label">
          * {{ 'FORMAT_VIEW_DIALOG.BUSINESS_KEY_LABEL' | translate }}
          <celum-icon [configuration]="icons.info" [matTooltip]="'FORMAT_VIEW_DIALOG.BUSINESS_KEY_TOOLTIP' | translate"></celum-icon>
        </span>
        <mat-form-field celum-form-field size="large" [reserveHintSpace]="true">
          <input
            cdkFocusInitial
            data-test-business-key-input
            matInput
            formControlName="key"
            type="text"
            [placeholder]="'FORMAT_VIEW_DIALOG.BUSINESS_KEY_PLACEHOLDER' | translate"
            [maxLength]="validationLimits.key" />
          @if ((formatFormService.formatForm.controls.key.value.length | wrapFn: remainChars : validationLimits.key) <= 10) {
            <mat-hint data-test-format-view-businesskey-hint>
              {{
                'INPUT_HINTS.REMAINING_CHARS'
                  | translate: { remaining: formatFormService.formatForm.controls.key.value.length | wrapFn: remainChars : validationLimits.key }
              }}
            </mat-hint>
          }
          @if (formatFormService.formatForm.controls.key.errors?.['required']) {
            <mat-error data-test-format-view-businesskey-error-required>
              {{ 'VALIDATION.REQUIRED' | translate }}
            </mat-error>
          }
          @if (formatFormService.formatForm.controls.key.errors?.['maxlength']) {
            <mat-error data-test-format-view-businesskey-error-maxlength>
              {{ 'VALIDATION.MAX_LENGTH' | translate: { maxLength: '55' } }}
            </mat-error>
          }
          @if (formatFormService.formatForm.controls.key.errors?.['keyExists']) {
            <mat-error data-test-format-view-businesskey-error-keyexists>
              {{ 'FORMAT_VIEW_DIALOG.BUSINESS_KEY_UNIQUE_ERROR' | translate }}
            </mat-error>
          }
          @if (formatFormService.formatForm.controls.key.errors?.['pattern']) {
            <mat-error data-test-format-view-businesskey-error-pattern>
              {{ 'FORMAT_VIEW_DIALOG.BUSINESS_KEY_PATTERN_ERROR' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
      <localized-field
        [fieldName]="'NAME'"
        [formGroup]="formatFormService.formatForm.controls.name"
        [inputType]="'input'"
        [validationLimit]="validationLimits.name" />
      <localized-field
        [fieldName]="'DESCRIPTION'"
        [formGroup]="formatFormService.formatForm.controls.description"
        [inputType]="'textarea'"
        [placeholder]="formatFormService.descriptionPlaceholder?.()"
        [validationLimit]="validationLimits.description" />
      <div class="format-view-shared_section-header format-view-shared_extra-margin-top">
        <span class="format-view-shared_section-title">{{ 'FORMAT_VIEW_DIALOG.ICON_SECTION' | translate }}</span>
      </div>
      <div class="format-view_icons">
        @for (icon of formatService.icons; track $index) {
          <celum-icon
            class="format-view_select-icon"
            [attr.data-test-icon]="icon.id"
            [class.format-view_select-icon--selected]="formatFormService.formatForm.controls.icon.value === icon.id"
            [configuration]="icon.url | wrapFn: getIconConfiguration"
            (click)="formatFormService.formatForm.controls.icon.setValue(icon.id)"></celum-icon>
        }
      </div>
    </form>
  </div>
  <div class="format-view_section format-view_section--params">
    <div class="format-view-shared_section-header">
      <span class="format-view-shared_section-title">{{ 'FORMAT_VIEW_DIALOG.PARAMS_SECTION' | translate }}</span>
      @if (isAdmin()) {
        <div class="format-view-shared_toggle-group">
          <span class="format-view-shared_toggle-label">{{ 'FORMAT_VIEW_DIALOG.TOGGLE_ALL_PARAMS' | translate }}</span>
          <mat-slide-toggle class="format-view-shared_toggle" [checked]="showHiddenFields" (change)="onShowHiddenFieldsChange()"></mat-slide-toggle>
        </div>
      }
    </div>

    @if (formatFormService.warningDialogDisabled && formatStore.selectedFormatId()) {
      <message-box class="format-view_change-warning" [text]="'CHANGE_WARNING.BANNER'" [type]="'warn'" />
    }

    <div class="format-view-shared_field">
      <span class="format-view-shared_field-label">{{ 'FORMAT_VIEW_DIALOG.SPECIFICATION' | translate }}</span>
      <mat-form-field celum-form-field class="format-view-shared_field--bg-white" size="medium" [reserveHintSpace]="true">
        <mat-select
          data-test-specification-field
          [errorStateMatcher]="alwaysShowMatcher"
          [formControl]="specControl"
          [hideSingleSelectionIndicator]="true"
          [panelClass]="'format-view-shared_select-panel'">
          @if (invalidSpecSelected()) {
            <mat-option data-test-specification="none" [value]="formatSelectedSpecId() ?? 0">{{ 'FORMAT_VIEW_DIALOG.NONE' | translate }}</mat-option>
          }
          @for (spec of specStore.entities() | wrapFn: sortSpecifications; track spec.id) {
            <mat-option [attr.data-test-specification]="spec.key" [value]="spec.id">{{ spec.key }}</mat-option>
          }
        </mat-select>
        <celum-icon [configuration]="icons.arrow" matSuffix></celum-icon>
        @if (!specStore.isSpecContractLoading() && !invalidSpecSelected()) {
          <mat-hint>{{ specStore.specDescription() }}</mat-hint>
        }
        @if (invalidSpecSelected()) {
          <mat-error>
            {{ 'FORMAT_VIEW_DIALOG.ERROR.INVALID_SPEC' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>

    <mat-divider class="format-view_divider format-view_divider--full"></mat-divider>
    @if (invalidSpecSelected()) {
      <empty-page class="format-view_invalid-spec" [config]="noValidSpecConfig"></empty-page>
    } @else {
      @if (specStore.isSpecContractLoading()) {
        <mat-progress-spinner class="format-view_spinner" mode="indeterminate" [diameter]="32"></mat-progress-spinner>
      } @else {
        <div class="format-view_contract-wrapper">
          <spec-params [specFormGroup]="formatFormService.formatForm.controls.parameters" [showHiddenFields]="showHiddenFields"></spec-params>

          @if (specStore.fileExtensions().length > 0) {
            <file-extensions></file-extensions>
          }
        </div>
      }
    }
  </div>
</div>
